import { AxiosResponse } from "axios";
import { apiServiceV2 } from ".";
import { CompanyInfoResponese } from "./types";

export const getCompanyInfo = async (): Promise<CompanyInfoResponese> => {
	const response: AxiosResponse<CompanyInfoResponese> = await apiServiceV2.get("/companies/info");
	return response.data;
};
